import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRoleDestination } from '../utils/roleDestination';

export function useRedirectIfLoggedIn(destination) {
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${window.REACT_APP_API_ENDPOINT}/api/users/current-user`, { credentials: 'include' })
            .then(res => res.json())
            .then(data => {
                if (data.user) {
                    const dest = destination || getRoleDestination(data.user.rol?.nombre);
                    navigate(dest, { replace: true });
                }
            })
            .catch(() => {});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
